/* Register a service worker per app-shell so both the driver and admin
 * consoles are installable PWAs. We keep the customer-facing routes free of
 * a service worker. */

export function registerDriverSW() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!window.location.pathname.startsWith('/driver')) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/driver' })
      .catch(() => { /* silently ignore SW registration failure */ });
  });
}

export function registerAdminSW() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!window.location.pathname.startsWith('/admin')) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/admin-sw.js', { scope: '/admin' })
      .catch(() => { /* silently ignore SW registration failure */ });
  });
}
